import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { HttpClientModule } from '@angular/common/http';

import { PhoneInputComponent } from './devextreme-phone-input.component';

import { DxValidatorModule } from 'devextreme-angular/ui/validator';
import { DxTemplateModule } from 'devextreme-angular/core/template';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';


@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        CommonModule,
        FormsModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxTemplateModule
    ],

    declarations: [
        PhoneInputComponent
    ],

    exports: [
        PhoneInputComponent
    ],

    providers: [Title],

    bootstrap: [PhoneInputComponent],

    entryComponents: []
})

export class DevextremePhoneInputModule { }



// WEBPACK FOOTER //
// ./src/custom_modules/devextreme-phone-input/devextreme-phone-input.module.ts